import { E2E_ROUTE_NAMES } from './constants'

export const E2E_CONFIG = {
  [E2E_ROUTE_NAMES.PAGE]: 'end2EndTests',
}
